<template>
  <div>

    <error-dialog :status="sendCodeStatus" />
    <error-dialog :status="verifyCodeStatus" />

    <v-slide-x-transition v-if="!sendCodeStatus.resolved" leave-absolute>
      <v-form ref="email-form" @submit.prevent="sendCode">
      <v-text-field
        class="mt-0"
        v-model="email"
        name="Email address"
        label="Email address"
        hint="We'll send you an email with a temporary code"
        persistent-hint
        :rules="[ isValid ]"
        @keydown.stop
      >
        <template v-slot:append>
          <v-btn
            style="margin-bottom: 5px;"
            small color="primary" type="submit"
            :loading="sendCodeStatus.pending"
            :disabled="!isValid(email)"
          >
            Send
          </v-btn>
        </template>
      </v-text-field>
      </v-form>
    </v-slide-x-transition>
    <v-slide-x-reverse-transition v-else leave-absolute>
      <code-input
        ref="code-input"
        class="mb-1 mt-2"
        :busy="verifyCodeStatus.pending"
        :invalid="codeHasError"
        :exp="exp"
        type="email"
        @reset="sendCodeStatus.reset()"
        @reset-code="codeHasError = false"
        @verify="verifyCode"
      />
    </v-slide-x-reverse-transition>
  </div>
</template>


<script>
import CodeInput from '@/components/CodeInput.vue';
import getBrowserIdentity from '@/utils/browser-identity.js';
import { opDevFetch } from '@/utils/op-dev-fetch';
import { EMAIL_REGEX } from '@/utils/email.js';
import { OPError } from '@/utils/op-dev-fetch';

export default {
  name: 'sign-in-email',

  components: {
    CodeInput
  },

  props: {
    subscribe: Boolean,
    brandedOrgId: String,
    refresh: { type: Boolean, default: true },
    defaultEmail: String
  },

  data() {
    return {
      email: this.defaultEmail,
      sendCodeStatus: this.$track('sendCode'),
      verifyCodeStatus: this.$track('verifyCode'),
      codeHasError: false
    };
  },

  methods: {
    isValid(email) {
      return !!(email && EMAIL_REGEX.test(email));
    },

    async sendCode() {
      if (!this.$refs['email-form'].validate())
        return;
      this.codeHasError = false;
      try {
        this.exp = await this.$callWithCaptcha(
          'send-sign-in-code',
          'sign_in',
          { email: this.email, path: this.$route.fullPath, org_id: this.brandedOrgId }
        );
      } catch (e) {
        if (e instanceof OPError && e.type == 'ClientException')
          throw new VisibleError(e.error || 'Error sending sign in code');
        throw e;
      }
    },

    async verifyCode(code) {
      try {
        const params = {
          email: this.email,
          method: 'CODE',
          payload: code,
          subscribe: this.subscribe,
          browser: getBrowserIdentity()
        };
        const jwt = await this.$call('get-jwt', params, this.refresh);
        this.$emit('sign-in', jwt);
      } catch (e) {
        if (e.type == 'AuthenticationException') {
          this.codeHasError = true;
          return;
        }
        throw e;
      }
    },

    reset() {
      this.$refs['code-input'] && this.$refs['code-input'].reset();
    }
  },

  watch: {
    isSignedIn: {
      immediate: true,
      handler(v) {
        if (v)
          this.email = this.global.profile.email;
      }
    }
  }
}
</script>
